export default __webpack_public_path__ + "static/media/Z2.848bce18.svg";